import { serviceProvider } from "../../../../../comun/provider/ServiceProvider";
import { CompraAnimalesResponse } from "../../../../../modulos/pesaje/ganaderia/response/CompraAnimalesResponse";
import { BaseFullScreenModalRender } from "../../../../base/modal/BaseFullScreenModalRender";
import { IConnectRender } from "../../../../definitions/IConnectRender";
import { CompraDetailRender } from "../detail/CompraDetailRender";

/** Modal a pantalla completa (solo lectura) con el detalle de una compra. */
export class CompraDetailModalRender extends BaseFullScreenModalRender {
  protected readonly elementId = "compraDetailModal";

  constructor(private readonly _compra: CompraAnimalesResponse) {
    super();
  }

  protected get title(): string {
    return `Compra ${this._compra.codigo ?? ""}`;
  }

  protected get subtitle(): string | undefined {
    return serviceProvider.getFincaSelectedService().getRequired().nombreFinca;
  }

  protected getContent(): IConnectRender {
    return new CompraDetailRender(this._compra);
  }
}
